/*
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description:
 */
import NProgress from "nprogress"; //页面顶部进度条引入
import router from "./index";
import store from "@/store";
//增加白名单  直接放行
const whiteList = [
  "/thirdLogin", //
  "/login/core", //系统切换
  "/bsgl", //标识管理子系统
  "/dsj", //产业大数据中心
  "/xxfb", //信息发布系统
  "/qlzs", //繁育养殖管理子系统
  "/bagl", //备案管理子系统
  "/xmtz", //畜牧屠宰管理系统
  "/zljg", //质量监管系统
  "/login",
  "/cockpit/index", //大屏首页
  "/cockpit/useActivity", //使用活跃度
  "/cockpit/traceSource", //消费者溯源
  "/cockpit/supervise", //生产监管
  "/cockpit/keepOnRecord", //企业备案
  "/sy",
  "/syInfo" //溯源查询
];
router.beforeEach((to, from, next) => {
  NProgress.start();
  store.commit("addRoutes", to.matched);
  let token = sessionStorage.getItem("token");
  if (whiteList.includes(to.path)) {
    next();
  } else {
    if (to.path != "/login/core" && !token) {
      next({ path: "/login/core" });
    } else if (to.path === "/login" && token) {
      next({ path: "/home" });
    } else {
      next();
    }
  }
});
router.afterEach(router => {
  NProgress.done();
  if (
    router.path != "/login/core" &&
    router.name != "404" &&
    router.meta.affix
  ) {
    if (
      store.state.tagsView.visitedPath &&
      !store.state.tagsView.visitedPath.some(item => {
        return item.fullPath === router.fullPath;
      })
    ) {
      let routes = JSON.parse(JSON.stringify(store.state.tagsView.visitedPath));
      let route = {
        fullPath: router.fullPath,
        path: router.path,
        meta: router.meta,
        query: router.query,
        name: router.meta.multiple
          ? router.query[router.meta.multiple]
          : router.meta.title,
        id: store.state.tagsView.currentPath
          ? store.state.tagsView.currentPath
          : new Date().getTime()
      };
      routes.push(route);
      store.commit("visitedPathAdd", routes);
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/routeGuard.js